import { jsx as t, jsxs as i } from "react/jsx-runtime";
import l from "../station-feature-icon/station-feature-icon.js";
import e from "./station-feature-list.module.less.js";
const m = ({ items: a }) => /* @__PURE__ */ t("ul", { className: e.list, children: a.map((s, r) => /* @__PURE__ */ i("li", { className: e.item, children: [
  /* @__PURE__ */ t("span", { className: e.icon, children: /* @__PURE__ */ t(l, { feature: s }) }),
  /* @__PURE__ */ t("span", { className: e.text, children: s.text })
] }, r)) });
export {
  m as default
};
